import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './LoginButton.css';

interface LoginButtonProps {
  className?: string;
}

const LoginButton: React.FC<LoginButtonProps> = ({ className = '' }) => {
  const { login, isLoading } = useAuth();

  const handleLogin = async () => {
    await login();
  };

  return (
    <button 
      className={`login-button ${className}`}
      onClick={handleLogin}
      disabled={isLoading}
    >
      {isLoading ? (
        <div className="spinner-small" />
      ) : (
        'Sign in with Microsoft'
      )}
    </button>
  );
};

export default LoginButton;